// @ts-nocheck
/* eslint-disable */
export const asMoveHandleIcon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="9.5" cy="6.5" r="1.5" fill="currentColor"/><circle cx="14.5" cy="6.5" r="1.5" fill="currentColor"/><circle cx="9.5" cy="12" r="1.5" fill="currentColor"/><circle cx="14.5" cy="12" r="1.5" fill="currentColor"/><circle cx="9.5" cy="17.5" r="1.5" fill="currentColor"/><circle cx="14.5" cy="17.5" r="1.5" fill="currentColor"/></svg>`,
    name: 'move-handle' as const
};